<template>
  <div class="w-11/12 lg:5/6 mx-auto px-20">
    <h1 class="uppercase mt-16 md:mt-10 py-3 text-xl md:text-2xl
    flex justify-start mx-auto tracking-widest">
      {{ $t('teacher.review') }}
    </h1>

    <div class="flex flex-col mt-6 w-11/12 md:w-3/4 mx-auto">
      <review-row v-for="review in reviews" :key="review.id" :review="review" />
    </div>
  </div>
</template>

<script>
import { getTeacherReviews } from '@/services/TeacherService';
import ReviewRow from './ReviewRow.vue';

export default {
  components: { ReviewRow },
  data() {
    return {
      reviews: [],
    };
  },

  created() {
    this.getReviews();
  },

  methods: {
    getReviews() {
      getTeacherReviews(this.$route.params.slug).then(({ data }) => {
        this.reviews = data.splice(0, 3);
      });
    },
  },
};
</script>
